import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/loadable-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/pill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/product/add-to-cart-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/tile-row.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/tiles/book.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/tiles/full-width-title/shelf-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/tiles/full-width-title/summary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/tiles/title.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/title-star-rating.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/styles/pages/series.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/styles/components/tiles/full-width-title.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/styles/components/typography/heading.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/styles/components/page-components/banner-image.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/styles/components/callout.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/styles/components/card.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
